export function extractApiError(e, fallback) {
    if (e && typeof e === "object") {
        const err = e;
        return (err?.response?.data?.message ??
            err?.response?.data?.error ??
            err?.message ??
            fallback);
    }
    return fallback;
}
